module.exports = __webpack_public_path__ + "static/media/javascript.1087a459.svg";